import Payment from 'app/src/data/models/Payment';
import RetailCollection from 'app/src/data/models/RetailCollection';
import URLHelper from 'app/src/data/models/utils/URLHelper';

export default class PaymentCollection extends RetailCollection {
  get model() {
    return Payment;
  }

  /**
   * Return the REST url for collection of payment service Payments
   * @returns {string} the url representing the REST endpoint
   */
  url() {
    return URLHelper.getAccountURL('/Payment.json');
  }

  /**
   * Overridden to parse out superfluous json that the current LSCloud returns us
   * @param response
   * @returns {*}
   */
  parse(response) {
    // response.Payment is an array of the Payment structures we want.
    // Return it directly if an object is found; otherwise return an empty array and let
    // Backbone handle it
    return response.Payment || [];
  }
}
